module.exports = __webpack_public_path__ + "static/yardwork-ef2b4f2603cd2c54dbb409e3b4953263.jpg";